module.exports = __webpack_public_path__ + "static/img/jagdish.2238493a.jpg";